import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import "react-datetime/css/react-datetime.css";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useNavigate } from "react-router-dom";

import DataTable from "examples/Tables/DataTable";

import { useEffect, useState } from "react";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ImageModal from "components/ImageModal";
import EmptyData from "components/EmptyData";
import apiClient from "Utils/apiClient";
import socketService from "../../socket/newsocketService";
import { useSelector } from "react-redux";

function SimDetailsPage() {
  const navigate = useNavigate();
  const [allRows, setAllRows] = useState([]);
  const [rows, setRows] = useState([]);
  const storedUserState = JSON.parse(localStorage.getItem("user"))?.state || "";
  const selectedState = useSelector((state) => state?.data?.getUserState);
  const [searchTxt, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [onClickImageData, setOnClickImageData] = useState("");

  const columns = [
    {
      Header: <span style={{ color: "blue" }}>Sr</span>,
      accessor: "Sr",
      width: "5%",
      align: "left",
    },
    {
      Header: <span style={{ color: "blue" }}>Image</span>,
      accessor: "Image",
      width: "10%",
      align: "left",
    },
    {
      Header: <span style={{ color: "blue" }}>Name</span>,
      accessor: "Name",
      width: "10%",
      align: "left",
    },
    {
      Header: <span style={{ color: "blue" }}> Email</span>,
      accessor: "Email",
      width: "10%",
      align: "left",
    },
    {
      Header: <span style={{ color: "blue" }}> State</span>,
      accessor: "State",
      width: "10%",
      align: "left",
    },

    {
      Header: <span style={{ color: "blue" }}>Phone</span>,
      accessor: "Phone",
      width: "10%",
      align: "left",
    },
    {
      Header: <span style={{ color: "blue" }}>IMEI Number</span>,
      accessor: "IMEINumber",
      width: "10%",
      align: "left",
    },
    {
      Header: <span style={{ color: "blue" }}>Primary Network Provider</span>,
      accessor: "primarynetworkprovider",
      width: "10%",
      align: "left",
    },
    {
      Header: <span style={{ color: "blue" }}>Secondary Mobile</span>,
      accessor: "secondorymobile",
      width: "10%",
      align: "left",
    },
    {
      Header: <span style={{ color: "blue" }}>Secondary Network Provider</span>,
      accessor: "secondorynetworkprovider",
      width: "10%",
      align: "left",
    },
    {
      Header: <span style={{ color: "blue" }}>Action</span>,
      accessor: "Action",
      width: "10%",
      align: "left",
    },
  ];

  const handleImageClick = (url) => {
    setIsModalOpen(true);
    setOnClickImageData(url);
  };

  const getData = async () => {
    setLoading(true);

    try {
      const userData = JSON.parse(localStorage.getItem("user")) || {};
      const { superAdmin } = userData;
      const activeState = selectedState || storedUserState || "All State";
      const queryState = superAdmin && activeState === "All State" ? "" : activeState;
      const response = await apiClient.get("/users/sim-details", {
        params: queryState ? { state: queryState } : {},
      });

      const users = Array.isArray(response?.data)
        ? response.data
        : Array.isArray(response?.data?.data)
          ? response.data.data
          : [];

      const nextRows = users.map((item, index) => ({
        key: item?.userId || item?.id || item?._id?.toString?.() || null,
        Sr: index + 1,
        Name: item?.userName || "",
        Email: item?.userEmail || "",
        State: item?.state || item?.userState || "",
        Image: (
          <img
            onClick={() => handleImageClick(item?.userImage)}
            src={item?.userImage}
            alt="user"
            style={{
              width: "50px",
              height: "50px",
              borderRadius: "50%",
              cursor: "pointer",
            }}
          />
        ),
        Phone: item?.userPhone || "",
        IMEINumber: item?.sim?.IMEINumber || "",
        primarynetworkprovider: item?.sim?.primarynetworkprovider || "",
        secondorymobile: item?.sim?.secondorymobile || "",
        secondorynetworkprovider: item?.sim?.secondorynetworkprovider || "",
        loggedIn: item?.loggedIn || false,
        userState: item?.userState || "",
        Action: item?.loggedIn ? (
          <button
            className="btn btn-danger btn-sm"
            onClick={() => acceptWorker(item)}
          >
            Clear Login
          </button>
        ) : (
          "----"
        ),
      }));

      setAllRows(nextRows);
      setRows(nextRows);
    } catch (error) {
      toast.error(error?.message || "Failed to load SIM details");
      setAllRows([]);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (!user) {
      navigate("/authentication/sign-in");
    }

    getData();
    const handleRefresh = () => {
      console.log("[SimDetailsPage][socket] simdetailsrefresh received");
      getData();
    };

    socketService.on("simdetailsrefresh", handleRefresh);

    return () => {
      socketService.off("simdetailsrefresh", handleRefresh);
    };
  }, [selectedState, navigate]);

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  useEffect(() => {
    if (searchTxt === "") {
      setRows(allRows);
      return;
    }

    const searchWithoutPlus = searchTxt.replace(/\+/g, "").toLowerCase();
    const filteredRows = allRows.filter((row) => {
      const phoneWithoutPlus = String(row.Phone || "").replace(/\+/g, "").toLowerCase();
      const nameValue = String(row.Name || "").toLowerCase();
      const emailValue = String(row.Email || "").toLowerCase();
      const imeiValue = String(row.IMEINumber || "").toLowerCase();

      return (
        phoneWithoutPlus.startsWith(searchWithoutPlus) ||
        nameValue.startsWith(searchWithoutPlus) ||
        emailValue.includes(searchWithoutPlus) ||
        imeiValue.includes(searchWithoutPlus)
      );
    });

    setRows(filteredRows);
  }, [searchTxt, allRows]);

  const acceptWorker = (item) => {
    const userId = item?.userId || item?.id || item?._id?.toString?.();

    if (!userId) {
      return;
    }

    apiClient
      .put(`/users/${userId}`, {
        loggedIn: false,
      })
      .then(() => {
        toast.info("Login status updated");
        const emitted = socketService.emit("simdetailsrefresh", {
          userId,
          state: item?.state || item?.userState || "",
          source: "simdetailspage",
        });

        if (!emitted) {
          getData();
        }
      })
      .catch((error) => {
        toast.error(error?.message || "Failed to update login status");
      });
  };

  const onClose = () => {
    setIsModalOpen(false);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar value={searchTxt} onChange={handleSearchChange} />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6} style={{ position: "relative", minHeight: "60vh" }}>
          {loading ? (
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Loading...
            </div>
          ) : (
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <ToastContainer />
                  <MDTypography variant="h6" color="white">
                    User's SIM Details
                  </MDTypography>
                </MDBox>

                <MDBox pt={3}>
                  {rows.length > 0 ? (
                    <DataTable
                      table={{ columns, rows }}
                      isSorted={false}
                      entriesPerPage={false}
                      showTotalEntries={false}
                      noEndBorder
                    />
                  ) : (
                    <EmptyData />
                  )}
                </MDBox>
              </Card>

              <ImageModal
                onClickImageData={onClickImageData}
                onClose={onClose}
                isModalOpen={isModalOpen}
              />
            </Grid>
          )}
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default SimDetailsPage;
